import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  IfComponent,
  AssignmentStatus,
  TFVButton,
  Attachment,
  Translate,
  Rating,
  ArrowButton,
  LeftDrawerSlide,
  Modal,
  Dialog,
} from '../../../Share/components';
import NotificationItem from './NotificationItem';
import './style.scss';

const propTypes = {
  notifications: PropTypes.array,
  onClose: PropTypes.func,
  isVisible: PropTypes.bool,
};

function AssignmentDetail({
  notifications = [],
  onClose = () => {},
  isVisible = false,
}) {
  return (
    <>
      {isVisible && (
        <LeftDrawerSlide
          isVisible={isVisible}
          hideClose
          hideExternalScroll
          onClose={onClose}
          className="tk-notification-detail__drawer"
        >
          <Dialog
            className="tk-notification-detail__container"
            isVisible
            onClose={onClose}
          >
            <div className="tk-assignment-list-box_header text-center">
              {Translate({ content: 'notification.events' })}
            </div>
            <div className="tk-assignment-list-box_body p-2">
              <div className="tv-workassignment__detail-wrapper d-flex flex-column h-100">
                {notifications &&
                  notifications.map(item => (
                    <NotificationItem
                      HeadLine={item.Headline}
                      Datetime={moment(item.DatetimeSent).format(
                        'YYYY-MM-DD HH:mm',
                      )}
                      isNew
                      key={item.NotificationIdentifier}
                    />
                  ))}
              </div>
            </div>
          </Dialog>
        </LeftDrawerSlide>
      )}
    </>
  );
}

AssignmentDetail.propTypes = propTypes;

export default AssignmentDetail;
